import React from 'react'
import routes from '../config/settings/routes'
import { DownloadsNavProvider } from '../components/Navigation/DownloadsNavButton.context'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import DownloadsLayout from '../components/Layouts/DownloadsLayout'
import CantFindDataFormContainer from '../containers/CantFindDataForm/CantFindDataForm.container'
import DownloadPurchasePlanSection from '../containers/DownloadPurchasePlanSection/DownloadPurchasePlanSection.container'
import FooterContainer from '../containers/Footer/Footer.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'
import NotFoundPage from './NotFound'

const renderNotFound = () => <NotFoundPage />

/**
 * The DownloadPurchasePlan's page.
 */
const DownloadPurchasePlan = () => {
  return (
    <ProtectByFeatures
      fallback={renderNotFound}
      rule={features => features['cl.chilecompra.datos-abiertos/downloads-page']}
    >
      <BrandLayout footer={<FooterContainer margin="0" />}>
        <TopNavbarContainer menuActive={routes.downloads} />
        <SearchBuyerPanelContainer />
        <DownloadsNavProvider>
          <DownloadsLayout menuActive={routes.downloadPurchasePlan}>
            <DownloadPurchasePlanSection />
          </DownloadsLayout>
        </DownloadsNavProvider>
        <CantFindDataFormContainer />
      </BrandLayout>
    </ProtectByFeatures>
  )
}

export default DownloadPurchasePlan
